module.exports = __webpack_public_path__ + "static/media/login-bg-1-success.2a348ead.png";